import Grid from '@mui/material/Grid';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { observer } from 'mobx-react-lite';
import React from 'react';

import SortingIcon from '../../../components/SortingIcon/SortingIcon';
import useStyles from './UsersStyle';

const UsersHeader: React.FC<{
  userHeader: any;
  adminUsersStore: any;
}> = ({ userHeader, adminUsersStore }) => {
  const classes = useStyles();

  const sortBY = async (e: any) => {
    adminUsersStore.setSortBy(e);
    adminUsersStore.setSortDirection(
      adminUsersStore.SortDirection === 'desc' ? 'asc' : 'desc',
    );
    adminUsersStore.setShowLoader(true);
    await adminUsersStore.fetchAdminsBySorting();
    adminUsersStore.setShowLoader(false);
  };

  return (
    <TableRow>
      {userHeader.map(
        (header: any, index: number) =>
          header.show && (
            <TableCell key={index} className={classes.tableHeaderBg}>
              <Grid item xs={12}>
                <Typography
                  component={'div'}
                  noWrap
                  style={{ alignItems: 'center', display: 'flex' }}>
                  <Typography
                    component={'div'}
                    sx={{
                      color: header.name === 'name' ? '#241A2E' : '#979598',
                      fontFamily: 'FiraSans-Regular',
                      fontSize: '12px',
                      letterSpacing: 0,
                      lineHeight: '14px',
                    }}>
                    {header.label}
                  </Typography>
                  {header !== '' && header.name !== '' && (
                    <SortingIcon
                      {...{
                        sortBY,
                        sortByName: header.name,
                        store: adminUsersStore,
                      }}
                    />
                  )}
                </Typography>
              </Grid>
            </TableCell>
          ),
      )}
    </TableRow>
  );
};

export default observer(UsersHeader);
